module.exports = __webpack_public_path__ + "static/media/thailand.132929c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/thailand.png
// module id = 45
// module chunks = 0